import React, {Component, PropTypes} from 'react';
import IconListItem from './components/IconListItem';
import Tag from './components/Tag';

// eslint-disable-next-line react/prefer-stateless-function
export default class AppContextual extends Component {
  static propTypes = {
    contextual: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {contextual: props.contextual};
  }

  componentWillMount() {
    this.setState({
      contextual: this.props.contextual,
    });
  }

  componentDidMount() {
    if (global.TES) {
      global.TES.events.on('showContextual', (eventName, contextual) => {
        this.setState({contextual});
      });
    }
  }

  render() {
    const {contextual} = this.state;
    const contextualContext = contextual.contextType;

    const linkHandler = (e, url) => {
      global.TES.events.trigger('contextualLinkClicked', url);
      e.preventDefault();
    };

    const tagHandler = (e, tag, contextType) => {
      global.TES.events.trigger('contextualTagClicked', tag, contextType);
      e.preventDefault();
    };

    const listItem = (question, count) => {
      const link = `/answers/${question.url}`;

      return (<li key={question.id} className="contextual-list__item ">
        <div className="contextual-list__item-icon-container">
          <IconListItem name="Views" value={count} />
        </div>
        <a className="contextual__link link--unstyled" href={link} onClick={(e) => linkHandler(e, question.url)}>
          {question.title}
        </a>
      </li>);
    };

    const listTopic = (topic, contextType) => (
      <Tag
        key={topic.tag}
        name={topic.tag}
        hasSpacing
        className="t-tag"
        onClick={(e) => tagHandler(e, topic.tag, contextType)}
      />
    );
    const hasMostViewedUnanswered = !!(contextual['most-viewed-unanswered'] && contextual['most-viewed-unanswered'].length);
    const mostViewedUnanswered = contextual['most-viewed-unanswered'] && contextual['most-viewed-unanswered'].map((question, index) => listItem(question, index + 1));
    const hasMostPopularTags = contextual['most-popular-tags'] && !!contextual['most-popular-tags'].length;
    const mostPopularTags = contextual['most-popular-tags'] && contextual['most-popular-tags'].map((tag) => listTopic(tag, contextualContext));

    return (
      <div className="contextual">
        { hasMostPopularTags &&
        <div className="margin-bottom-ml">
          <h3 className="t-popular-tags-header contextual__title contextual__title--purple">Most popular topics</h3>
          <div className="contextual-list contextual-list--padding-top">
            <div className="tag-list tag-list--has-spacing t-popular-tags-div">
              {mostPopularTags}
            </div>
          </div>
        </div> }
        { hasMostViewedUnanswered &&
        <div className="margin-bottom-ml">
          <h3 className="t-popular-unanswered-header contextual__title contextual__title--purple">Most popular unanswered</h3>
          <ul className="contextual-list list-unstyled t-most-viewed-unanswered-ul">
            {mostViewedUnanswered}
          </ul>
        </div> }
      </div>);
  }
}
